import { z } from "zod/v4";
import { checkCiudad } from "../api/check-ciudad";
import useFetch from "@/hooks/use-fetch";
import { Alert, CircularProgress, Collapse } from "@mui/material";
import { Form, FormProps } from "@/components/form";
import { getAllDepartamentos } from "../../departamentos/api/get-all-departamentos";
import { getDepartamento } from "../../departamentos/api/get-departamento";

export const addCiudadFormSchema = z.object({
    nombre: z.string().nonempty("Este campo es requerido"),
    codigo: z.string().nonempty("Este campo es requerido"),
    departamentoId: z.string().nonempty("Este campo es requerido"),
});

export default function AddCiudadForm({
    form,
    ...props
}: FormProps<z.input<typeof addCiudadFormSchema>>) {
    const { fetch, value, loading } = useFetch(async (codigo: string) => {
        if (codigo) return await checkCiudad(codigo);
        return undefined;
    }, { debounceMs: 500 });

    const ciudadExists = value !== null && value !== undefined;

    return <Form form={form} gap={3} {...props}>
        <Collapse in={ciudadExists} sx={{ marginY: "-10px" }}>
            <Alert severity={"warning"}>
                Ya existe una ciudad con ese código. No se pueden repetir códigos de ciudad.
            </Alert>
        </Collapse>

        <Form.TextField name="nombre" label="Nombre" />
        <Form.TextField name="codigo" label="Código" onChange={e => fetch(e.target.value)}
            slotProps={{ input: { endAdornment: loading && <CircularProgress size={20} /> } }} />
        <Form.ModelComboBoxAsync
            name="departamentoId"
            label="Departamento"
            get={getDepartamento}
            getAll={getAllDepartamentos}
        />
        <Form.SubmitButton disabled={ciudadExists}>Guardar</Form.SubmitButton>
    </Form>;
}
